import { render, staticRenderFns } from "./AppGithubCorner.vue?vue&type=template&id=299f8ee4&scoped=true&"
import script from "./AppGithubCorner.vue?vue&type=script&lang=js&"
export * from "./AppGithubCorner.vue?vue&type=script&lang=js&"
import style0 from "./AppGithubCorner.vue?vue&type=style&index=0&id=299f8ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f8ee4",
  null
  
)

export default component.exports